import type { MutationConfig } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { useMutation } from "react-query";
import { VouchersDistributionsRepository } from "../vouchers-distribution.api";
import type { VerifyPhoneErrorResponse } from "./verify-phone.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type UseVerifyPhoneOptions = {
  config?: MutationConfig<typeof vouchersDistributionsRepository.verifyPhone, AxiosError<VerifyPhoneErrorResponse>>;
};

export const useVerifyPhone = ({ config }: UseVerifyPhoneOptions = {}) => {
  return useMutation({
    ...config,
    mutationFn: (data) => vouchersDistributionsRepository.verifyPhone(data),
  });
};
